import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, logoutApi } from "../api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await fetchMe();
      setUser(r.data.user);
      setCompany(r.data.company);
    } catch {
      setUser(null);
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    await logoutApi().catch(() => {});
    setUser(null);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, profile: user, company, loading, refresh, refreshUser: refresh, logout, setUser, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
};
